import { withStyles } from '@material-ui/core';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import XAPPButton from '../../Core/Components/Button/XAPPButton';
import EmpresaTarefaDialog from './EmpresaTarefaDialog';
import EmpresaTarefaList from './EmpresaTarefaList';
import * as Actions from './Store/Actions/EmpresaTarefaActions';
import EmpresaTarefaReducer from './Store/Reducers/EmpresaTarefaReducer';

const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99,
        color: theme.palette.text.primary,
    },
    toolbar: {
        background: theme.palette.type === 'dark' ? '#303030' : '#E6E6E6',
        borderRadius: "4px 4px 0 0"
    },
});

class EmpresaTarefaApp extends XAPPComponent {

    state = {
        open: null
    }

    openDialog = (_AValue) => {
        this.setState({ open: _AValue });
    }

    render() {
        const { onChange, idparent, classes, tipo, xappRouteParams } = this.props;

        return (
            <div className="flex flex-col w-full">
                <CatchErro url={this.props.match.url}>
                    <div className={clsx(classes.toolbar, "w-full flex flex-row items-start justify-start items-center")}>
                        <XAPPButton
                            tooltip={{ "title": "Adicionar", "placement": "top" }}
                            type="Icon"
                            className={clsx("p-8")}
                            variant="contained"
                            color="action"
                            onClick={() => this.openDialog({ tipo, idparent })}
                            iconProps={"justify-center text-20"}
                            icon={"add"}
                        />
                    </div>
                    <EmpresaTarefaList
                        xappRouteParams={xappRouteParams}
                        onChange={onChange}
                        idparent={idparent}
                    />
                    <EmpresaTarefaDialog
                        xappRouteParams={xappRouteParams}
                        openDialog={this.openDialog}
                        open={this.state.open}
                    />
                </CatchErro>
            </div>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ EmpresaTarefaApp }) {
    return {
        EmpresaTarefa: EmpresaTarefaApp.data,
    }
}

export default withReducer('EmpresaTarefaApp', EmpresaTarefaReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaTarefaApp))));
